class CleverTapSdk {
  handleEventtracking(eventData, eventName = "ExamWarriorsV2") {
    let device = "";
    try {
      if (localStorage.getItem("device")) {
        device = localStorage.getItem("device");
      } else {
        device = "pwa";
      }
    } catch (error) {}
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      eventData["userid"] = user.userid;
    }

    eventData["Date"] = new Date();
    eventData["device"] = device;
    // console.log("eventName", eventName);
    // console.log("eventData", eventData);
    if (window.clevertap) {
        console.log(window.clevertap.event.push(eventName, eventData));
    } else {
        setTimeout(function () {
            new CleverTapSdk().handleEventtracking(eventData, eventName);
        }, 100)
    }
  }

  handleProfiletrackinig(name, eventName = "ExamWarriorsV2") {
    let user = JSON.parse(localStorage.getItem("user"));
    let device = "";
    try {
      if (localStorage.getItem("device")) {
        device = localStorage.getItem("device");
      } else {
        device = "pwa";
      }
    } catch (error) {}

    let ctprofile = {};
    ctprofile["name"] = name ? name : user.user_name_display;
    ctprofile["id"] = user.userid;
    ctprofile["device"] = device;
    ctprofile["Identity"] = user.userid;
    console.log("eventName ", eventName);
    console.log("ctprofile ", ctprofile);

    // CleverTapSdk.handleEventtracking(ctdata, eventName);
    // if (window.clevertap) {
    //   console.log(window.clevertap.profile.push(ctprofile));
    // } else {
    //   setTimeout(function () {
    //     new CleverTapSdk().handleProfiletrackinig();
    //   }, 100);
    // }
  }
}

export default new CleverTapSdk();
